// OrderForm.js
import React, { useState, useEffect } from 'react';
import { Modal, Form, Input, Button, Select, notification, Table } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import '../../css/pdf.css';
import { deleteInvoiceDoc, fetchHistoryOrderDetails, postOrderDetails, uploadInvoiceDoc } from '../../features/Voyage/VoyageSlice';
import '../../css/order.css';
import DownloadOrder from './DownloadOrder';
import { DownloadOutlined, UploadOutlined, DeleteOutlined } from '@ant-design/icons';

const { Option } = Select;

const OrderModal = ({ visible, onClose, vesselName, spotPrice }) => {
    const { order, orderHistory, selectedVoyage } = useSelector(state => state.voyage);
    const [form] = Form.useForm();
    console.log(typeof(spotPrice))

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [formData, setFormData] = useState({});
    const [fileList, setFileList] = useState([]);
    const dispatch = useDispatch();

    useEffect(() => {
        if (order) {
           form.setFieldsValue(
    formInputDetails.reduce((acc, curr) => {

        if (curr.key === "category") {
            acc[curr.name] = "eu-ets";
        }
        else if (curr.key === "product") {
    acc[curr.name] = "EUA Spot";
}
        else if (curr.key === "company_name") {
    acc[curr.name] = "AZOLLA";
}
else if (curr.key === "service_fee_rate") {
    acc[curr.name] = "0.003";
}
        else {
            acc[curr.name] = order[curr.key] || '';
        }

        return acc;
    }, {})
);
        }
    }, [order, form]);

    // useEffect(() => {
    //     const unsubscribe = form.watch((values) => {
    //         const volume = parseFloat(values.contract_volume_allowances || 0);
    //         const totalPrice = volume * parseFloat(spotPrice || 0);
    //         if (!isNaN(totalPrice)) {
    //             form.setFieldsValue({ total_purchase_price: totalPrice.toFixed(2) });
    //         }
    //     });
    //     return () => unsubscribe?.();
    // }, [form, spotPrice]);

      // Auto-calculate total purchase price based on volume and spot price
  const calculateTotalPrice = (event) => {
    const volume = parseFloat(event.target.value || 0);
    console.log(volume)
    const totalPrice = (volume * parseFloat(spotPrice || 0)).toFixed(3);
    form.setFieldsValue({ total_purchase_price: totalPrice });
  };

    const formInputDetails = [
        { name: 'trade_order_number', 
            label: 'Trade Order Number', 
            key: 'trade_order_number', 
            value: order?.trade_order_number, 
            isDisabled: true,
            type: 'text'
        },
        { name: 'trade_date', 
            label: 'Trade Date', 
            key: 'trade_date', 
            value: order?.trade_date, 
            isDisabled: true,
            type: 'date'
        },
        { name: 'currency', 
            label: 'Currency', 
            key: 'currency', 
            value: order?.currency, 
            isDisabled: true ,
            type: 'text'
        },
        { name: 'company_name', 
            label: 'Company Name', 
            key: 'company_name', 
            value: ' AZOLLA ', 
            isDisabled: true ,
            type: 'text'
        },
        { name: 'allowance_price', 
            label: 'Allowance Price', 
            key: 'allowance_price', 
            value: order?.allowance_price, 
            isDisabled: true ,
            type: 'text'
        },
        { name: 'delivery_date', 
            label: 'Delivery Date', 
            key: 'delivery_date', 
            value: order?.delivery_date, 
            isDisabled: true,
            type: 'text' 
        },
        { name: 'payment_date', 
            label: 'Payment Date', 
            key: 'payment_date', 
            value: order?.payment_date, 
            isDisabled: true,
            type: 'text' 
        },
        { name: 'azolla_representative', 
            label: 'Azolla Representative', 
            key: 'azolla_representative', 
            value: order?.azolla_representative, 
            isDisabled: true ,
            type: 'text'
        },
        { name: 'azolla_title', 
            label: 'Azolla Title', 
            key: 'azolla_title', 
            value:  order?.azolla_title, 
            isDisabled: true ,
            type: 'text'
        },
        { name: 'imo_number', 
            label: 'IMO Number', 
            key: 'imo_number', 
            value: order?.imo_number, 
            isDisabled: true,
            type: 'text'
        },
        { name: 'category', 
            label: 'Category', 
            key: 'category', 
            value: 'EU-ETS', 
            isDisabled: false,
            type: 'dropdown', // Change to 'dropdown'
            options: [
                {
                    value: 'eu-ets',
                    label: 'EU-ETS'
                },
                {
                    value: 'uk-ets',
                    label: 'UK ETS'
                }
            ]
        },
        { name: 'contract_volume_allowances', 
            label: 'Contract Volume Allowances', 
            key: 'contract_volume_allowances', 
            value: '', 
            isDisabled: false,
            type: 'text'
        },
        { name: 'product', 
            label: 'Product', 
            key: 'product', 
            value: 'EU Spot', 
            isDisabled: true,
            type: 'text'
        },
        { name: 'total_purchase_price', 
            label: 'Total Indicative Price', 
            key: 'total_purchase_price', 
            type: 'text', 
            value: '', 
            isDisabled: false 
        },
        { name: 'buyer_name', 
            label: 'Buyer Name', 
            key: 'buyer_name', 
            type: 'text', 
            value: '', 
            isDisabled: false 
        },
        { name: 'buyer_title', 
            label: 'Buyer Title', 
            key: 'buyer_title', 
            type: 'text', 
            value: '', 
            isDisabled: false 
        },
         { name: 'buyer_email', 
            label: 'Buyer Email', 
            key: 'buyer_email', 
            type: 'text', 
            value: '', 
            isDisabled: false 
        },
       {
    name: 'service_fee_rate',
    label: 'Service Fee Rate',
    key: 'service_fee_rate',
    type: 'text',
    value: '0.003',
    isDisabled: true
},
    ];

    const handleOk = () => {
        const requiredFields = ['category', 'contract_volume_allowances', 'product', 'total_purchase_price', 'buyer_name', 'buyer_title'];
        const emptyFields = requiredFields.filter(field => !form.getFieldValue(field));
    
        if (emptyFields.length > 0) {
            notification.error({
                message: 'Incomplete Form',
                description: 'Fill All the details before proceeding.',
                placement: 'topRight',
            });
            return;
        }
        form.validateFields()
            .then(values => {
                console.log('Form values:', values);
                dispatch(postOrderDetails(values)).then((result) => {
                    console.log(result.payload)
                    if (result.payload == "successfully uploaded") {
                        notification.success({
                            message: 'Success',
                            description: 'Order details have been successfully uploaded.',
                            placement: 'topRight',
                        });
                        setFormData(values);
                        setIsModalOpen(true);
                    }
                })
                onClose();
                form.resetFields(
                    formInputDetails
                        .filter(item => !item.isDisabled)
                        .map(item => item.name)
                );
            })
            .catch(info => {
                console.log('Validate Failed:', info);
            });
    };


    const handleKeyDown = (tab, event) => {
        const { key } = event;
        // Allow only digits, decimal point, and backspace
        if (!/^[0-9.\b]$/.test(key) && event.key !== 'Backspace') {
            event.preventDefault();
        }

    };


    const handleOrderDownload = (data) => {
        // console.log(data)
        setFormData(data);
        setIsModalOpen(true);
    }

    const handleInvoiceUpload = async (e, data) => {
        console.log(data)
        const file = e.target.files[0];
        if (file) {
            const formData = new FormData();
            formData.append('invoice_file', file);
            formData.append('name', file.name);
    
            const params = {
                trade_order_number: data?.trade_order_number,
                imo_number: data?.imo_number,
                file: formData,
            };
    
            try {
                const result = await dispatch(uploadInvoiceDoc(params));
                if (result.payload) {
                    dispatch(fetchHistoryOrderDetails({imo_number: data?.imo_number}))
                    notification.success({
                        message: 'Success',
                        description: 'PDF file has been successfully uploaded.',
                        placement: 'topRight',
                    });
                    setFileList([]); // Clear the file list after successful upload
                }else {
                    notification.error({
                        message: 'Upload Failed',
                        description: 'Failed to upload PDF file.',
                        placement: 'topRight',
                    });
                }
            } catch (error) {
                console.log(error)
            }
        }
    };

    const handleInvoiceDelete = async (data) => {
        const params = {
            trade_order_number: data?.trade_order_number,
            imo_number: data?.imo_number,
        };
        try {
            const result = await dispatch(deleteInvoiceDoc(params));
            if (result.payload) {
                dispatch(fetchHistoryOrderDetails({imo_number: data?.imo_number}))
                notification.success({
                    message: 'Success',
                    description: 'Invoice has been successfully deleted.',
                    placement: 'topRight',
                });
                setFileList([]); // Clear the file list after successful upload
            }else {
                notification.error({
                    message: 'Delete Failed',
                    description: 'Failed to delete invoice.',
                    placement: 'topRight',
                });
            }
        } catch (error) {
            console.log(error)
        }
    }

    const handleInvoiceDownload = (data) => {
        const anchor = document.createElement('a');
        anchor.href = data?.invoice_url;
        anchor.download = 'document.pdf';
        anchor.click();
    };
    
    
    const columns = [
            {
                title: 'Trade Order',
                dataIndex: 'trade_order_number',
                key: 'trade_order_number',
            },
            {
                title: 'Date Created',
                dataIndex: 'trade_date',
                key: 'trade_date',
            },
            {
                title: 'Order',
                key: 'order',
                render: (data) => <DownloadOutlined onClick={() =>handleOrderDownload(data)} style={{ fontSize: '18px', color: '#1890ff', cursor: 'pointer' }} /> 
            },
            {
                title: 'Invoice',
                key: 'invoice',
                render:  (data) => data?.invoice_url && data?.invoice_date_created ? 
                <div>
                <DownloadOutlined onClick={() => handleInvoiceDownload(data)} style={{ fontSize: '18px', color: '#1890ff', cursor: 'pointer', marginRight: "6px" }} /> 
                <DeleteOutlined onClick={() => handleInvoiceDelete(data)} style={{ fontSize: '18px', color: '#1890ff', cursor: 'pointer' }} /> 
                
                </div> :
                <label for={data?.trade_order_number}>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                        <UploadOutlined  style={{ fontSize: '18px', color: '#1890ff', cursor: 'pointer' }} />
                    </div>
                    <input type="file" id={data?.trade_order_number} onChange={(e) => handleInvoiceUpload(e, data)} style={{ display: "none" }} name="infile" multiple="" data-original-title="upload invoice" />
                </label>
            },
    ];



       const handleCategoryChange = (value) => {
    form.setFieldsValue({
        product: value === "eu-ets"
            ? "EUA Spot"
            : "UKA Spot"
    });
};


    return (
        <>
        <Modal
            title={null}
            visible={visible}
            onCancel={onClose}
            footer={null}
            width="80vw"
            centered
            bodyStyle={{ height: '80vh', display: 'flex', flexDirection: 'row' }}
        >
            {/* First part: Form */}
            <div className='order-form-container'>
                <div className="order-form-box">
                    <div className="order-form-title" >Order Details</div>
                    <Form
                        form={form}
                        layout="vertical"
                        name="orderForm"
                        initialValues={formInputDetails.reduce((acc, curr) => {
                          if (curr.name === "company_name") {
    acc[curr.name] = "AZOLLA";
}
else if (curr.name === "service_fee_rate") {
    acc[curr.name] = "0.003";
}
else {
    acc[curr.name] = curr.value || '';
}
                            return acc;
                        }, {})}
                    >
                        <div className="order-form-inputs">
                            {formInputDetails.map((item, index) => (
                                <div key={item.key || index} className="order-form-input">
                                   <Form.Item
    name={item.name}
    label={item.label}
>
    {item.type === 'dropdown' ? (
        <Select
            disabled={item.isDisabled}
            placeholder={`Select ${item.label}`}
            onChange={
                item.name === "category"
                    ? handleCategoryChange
                    : undefined
            }
        >
            {item.options.map(option => (
                <Option key={option.value} value={option.value}>
                    {option.label}
                </Option>
            ))}
        </Select>
    ) : (
        <Input
            value={item.value}
            disabled={item.isDisabled}
            type={item.type}
            onKeyDown={
                item.name === 'contract_volume_allowances' ||
                item.name === 'total_purchase_price'
                    ? (event) => handleKeyDown(item.name, event)
                    : undefined
            }
            onChange={
                item.name === 'contract_volume_allowances'
                    ? (event) => calculateTotalPrice(event)
                    : undefined
            }
        />
    )}
</Form.Item>
                                </div>
                            ))}
                        </div>
                    </Form>
                </div>
                <div className="order-form-footer" >
                    <Button type="primary" onClick={handleOk}>
                        Generate Order
                    </Button>
                </div>
            </div>

            {/* Second part: List */}
            <div className='order-list-container'>
                <div className='order-list-box'>
                    <div className="order-form-title">Order Historical Data</div>
                    <Table 
                        dataSource={orderHistory} 
                        columns={columns} 
                        pagination={false} 
                        rowKey="trade_order_number"
                    />
                </div>
                {/* <div style={{ borderTop: '1px solid #f0f0f0', paddingTop: '8px', textAlign: 'right' }}>
                    <Button>Something</Button>
                </div> */}
            </div>

        </Modal>
            
        <DownloadOrder data={formData} isModalOpen={isModalOpen} setIsModalOpen={setIsModalOpen} vesselName={vesselName}/>

        </>
    );
};

export default OrderModal;
